import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';

const useManagedEntities = () => {
  return useFlag(FlagType.ManagedEntities);
};

export const canUseManagedEntities: Permission = and([useManagedEntities]);
